@let badgeLabel = badgeLabel$ | async;

<ng-container *ngIf="tripType$ | async as tripType">
  <ng-container *ngIf="priceContext$ | async as priceContext">
    <section
      *ngIf="blockOffer$ | async as offer"
      class="relative block-offer elevation-level-1 elevation-transition-ease fill grow flex flex--column no-underline nordic-blue-25-bg surface-secondary rounded-large overflow-hidden"
      (click)="emitClick(priceContext.price?.travelClass, tripType); navigateToUrl(offer.link)"
      [class.inner-hover]="innerLinkHover"
      [attr.data-testid]="'offer-tile-heading-' + offer.title"
      tabindex="0"
    >
      <div class="offer-area white-bg surface-primary grow">
        <section class="destination-image relative" *ngIf="aspectRatio$ | async">
          <fin-content-image
            [aspectRatio$]="aspectRatio$"
            [imageData$]="offer.imageData | finToObservable"
            [maxImageWidth]="MaxImageWidth"
            [fetchPriority]="fetchImagePriority"
          />
        </section>

        @if (badgeLabel) {
          <fcom-tag
            [theme]="offer.enableBlackTeaser ? TagTheme.BLACK_FRIDAY : TagTheme.POPULAR"
            class="special-offer-tag absolute"
            data-testid="offer-tile-badge-label"
            [roundingStyle]="isNewBrand() ? TagRoundingStyle.CURVE_RIGHT : TagRoundingStyle.DEFAULT"
          >
            @if (offer.discountCode) {
              {{
                badgeLabel
                  | finLocalization
                    : {
                        amount:
                          offer.discountCode.type === 'fixed'
                            ? (discountCodeFixedAmount$ | async | finPrice: { stripZeroCents: true, useSymbol: true })
                            : offer?.discountCode?.amount,
                      }
              }}
            } @else {
              {{ badgeLabel | finLocalization }}
            }

            @if (offer.badgeIcon) {
              <fcom-icon className="white-text text-icon-reversed icon-small" [name]="offer.badgeIcon" />
            }
          </fcom-tag>
        }

        <section class="fill pr-xsmall destination-text-content">
          <a
            *ngIf="offer.title"
            class="no-decoration block price-link"
            [finLink]="offer.link"
            (beforeNavigation)="emitClick(priceContext.price?.travelClass, tripType)"
            data-testid="offer-tile-price-link"
          >
            <h3
              data-testid="offer-tile-title"
              class="font-heading-5 nordic-blue-900-text text-icon-primary mr-clear-y font-title-small truncate overflow-hidden"
            >
              {{ offer.title }}
            </h3>
            <ng-container [ngTemplateOutlet]="price" [ngTemplateOutletContext]="priceContext" />
          </a>
          @if (showPriceCalendarButton) {
            <div class="grow fill" [class.ps-xsmall-t]="isNewBrand()" [class.ps-xsmall-y]="!isNewBrand()">
              <fcom-button
                [text]="'destinationSearch.calendarButton' | finLocalization"
                [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                [mode]="ButtonMode.FILL"
                [size]="isNewBrand() ? ButtonSize.MEDIUM : ButtonSize.LARGE"
                (clickBtn)="emitCalendarClick($event, priceContext.price?.travelClass, tripType)"
                data-testid="block-offer-calendar-button"
              />
            </div>
          }
        </section>
      </div>
      <ng-container *ngIf="offer?.amDestination && flightHotelEnabled">
        <button
          (click)="
            openAmContinueModalClick(offer?.amDestination.bookUrl, offer?.title, offer?.destination);
            $event.stopPropagation()
          "
          (mouseenter)="innerLinkHover = true"
          (mouseleave)="innerLinkHover = false"
          class="block flight-hotel no-underline ps-small"
          data-testid="offer-tile-flight-hotel-price-link"
        >
          <span class="flex flex--space-between flex--wrap flex--center">
            <span
              class="nordic-blue-900-text text-icon-primary font-body-1 medium-type underline ps-xsmall-r offer-tile-flight-hotel-title font-label-medium"
              data-testid="offer-tile-flight-hotel-title"
            >
              {{ 'destinationSearch.flightsAndHotel' | finLocalization }}</span
            >
            <span class="nordic-blue-900-text text-icon-primary font-body-1 font-body-medium">
              <span>
                {{
                  'destinationSearch.flightAndHotelDuration' | finLocalization: { days: offer?.amDestination.duration }
                }}</span
              >
              <span class="ps-xsmall-l medium-type" data-testid="offer-tile-flight-hotel-price-value">{{
                offer?.amDestination.price | finPrice: { roundPrice: true } | finEmpty
              }}</span>
            </span>
          </span>
        </button>
      </ng-container>

      <ng-template #price let-price="price">
        <ng-container *ngIf="price && price.price; else noPrice">
          <div
            class="nordic-blue-900-text text-icon-primary mr-clear-t font-body-1 ps-xxsmall-y font-body-medium"
            [attr.data-testid]="'offer-tile-starting-from-label-' + tripType"
          >
            @if ((showRoundTripPrice$ | async) === true) {
              {{ 'productCard.startingFromTitle.return' | finLocalization }}
            } @else {
              {{ 'productCard.startingFromTitle.' + CmsTripTypeMap[tripType] | finLocalization }}
            }
          </div>
          <span
            class="offer-tile-price-value nordic-blue-900-text text-icon-primary font-heading-2 medium-type font-headline-small"
            [class.heather-700-text]="isHighlightPrice$ | async"
            [class.text-icon-accent]="isHighlightPrice$ | async"
            data-testid="offer-tile-price-value"
            [attr.data-oneway]="offer?.onewayPrice?.price | finPrice: { roundPrice: true } | finEmpty"
            [attr.data-return]="offer?.returnPrice?.price | finPrice: { roundPrice: true } | finEmpty"
            >{{ price.price | finPrice: { roundPrice: true } | finEmpty }}</span
          >
        </ng-container>
      </ng-template>

      <ng-template #noPrice>
        <div class="flex flex--middle mr-clear-t ps-xxsmall-y">
          <span
            class="nordic-blue-900-text text-icon-primary font-body-1 ms-xxsmall-r font-body-medium"
            data-testid="offer-tile-no-price-label"
            >{{ 'productCard.noPriceText' | finLocalization }}</span
          >
        </div>
      </ng-template>
    </section>
  </ng-container>
</ng-container>
